
import { defineComponent, computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    config: Object,
  },
  setup(props) {
    const useConfig = reactive(props.config);
    const store = useStore();
    const pageType = computed(() => store.getters.pageInfo);
    return {
      useConfig,
      pageType,
    };
  },
});
